import {SET_IDIOMA, IdiomaActionTypes} from "../types/idiomaActionTypes";
import {IIdioma} from "../../entities/catalogos/IIdioma";
import {Defaults} from "../../defaults/Defaults";

export const initialIdioma: IIdioma = {
    idioma: "",
    };

export function idiomaReducer(state = initialIdioma, action: IdiomaActionTypes): IIdioma {
    switch (action.type) {
        case SET_IDIOMA:
            return action.idioma;
        default:
            return state;
    }
}
